
if( !window.proficient ) {
  window.proficient = {}
}

if( !window.proficient.utils ) {
  window.proficient.utils = {}
}

if( !window.proficient.data ) {
  window.proficient.data = {}
}

// old app
// const LEND_THE_TREND_BASE_URL = 'http://localhost:3000/api'
// const LEND_THE_TREND_BASE_URL = 'https://lend-the-trend-rental-app.vercel.app/api'

// Security backup date: 06/march/2024
const LEND_THE_TREND_BASE_URL = 'https://lend-the-trend-rental-app-backup.vercel.app/api'

// main branch
// const LEND_THE_TREND_BASE_URL = 'https://lend-the-trend-rental-app-v2.vercel.app/api'
// const LEND_THE_TREND_BASE_URL = 'https://lend-the-trend-rental-app-v2.vercel.app/api'

// discount-fixes branch
// const LEND_THE_TREND_BASE_URL = 'https://lend-the-trend-rental-app-v2-git-discount-fixes-proficient-dev.vercel.app/api'


/**
 * this function get the booked days for a product
 * and save it in a global way to be accesible in all the store
 * @param { string | number } productId 
 */
const getBookedDays = async (productId) => {
  try {
    const res = await fetch(`${LEND_THE_TREND_BASE_URL}/reservations/${productId}`)
    const data = await res.json()

    return {
      bookedDays: data.bookedDays,
      hasFutureRentPending: data.hasFutureRentPending
    }

  } catch (error) {
    console.error(error)
    window.proficient.data = { bookedDays: [] }
  }
}

const createReservation = async (params, noBackup = false) => {
  const required = [
    'startDate',
    'productId',
    'variantId',
    'backupId',
    'backupVariantId',
    'rentPlanDurationInDays'
  ]

  if( !params || typeof params !== 'object')
    throw new Error('Params must be an object and must to have the following props: ' + required.join(', '))

  required.forEach( (key) => {
    if( noBackup ) {
      if( key === 'backupId' || key === 'backupVariantId') return
    }
    if( !params[key] ) {
      throw new Error(`${key} in params is mandatory`)
    }
  })

  try {
    let url = `${LEND_THE_TREND_BASE_URL}/reservations`

    if( noBackup ) {
      url += '?no-backup=true'
    }

    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify({...params}),
      headers: {
        'Content-Type': 'application/json'
      }
    })

    const data = await res.json()

    return data
  } catch (error) {
    console.error(error)
  }
}

const cancelReservationService = async (_id = '') => {
  if( !_id ) throw new Error('_id param is mandatory')
  
  const url = `${LEND_THE_TREND_BASE_URL}/reservations/${_id}`
  try {
    const res = await fetch(url, {
      method: 'DELETE',
    })
    
    return res
  } catch (error) {
    console.error(error)
  }
}

const fetchProduct = async (handle = '') => {
  if( handle === '') throw new Error('handle param is mandatory')

  const res = await fetch(`/products/${handle}.js`)
  const data = await res.json()
  return data
}


const getCartInfo = async () => {
  try {
    const res = await fetch('/cart.js')
    return res.json()
  } catch (error) {
    console.error(error)
  }
}

/**
 * utility function that adds a multiple items to cart
 */
const addProductsToCart = async (items = []) => {
  if( !items instanceof Array)
    throw new Error('variantIds must to be an array of ids')

  if( items.length === 0 ) return

  const newItems = items.map( (variant) => {
    return ({
      id: variant.id,
      quantity: variant.quantity || 1,
      properties: variant.properties || {}
    })
  })

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: JSON.stringify({
        items: newItems
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    })
    
    return await res.json()
  } catch (error) {
    console.error('An error occurred when trying to add an item to cart')
  }
}

/**
 * this remove the list of products from cart
 * @param { string[] } variantIds
 */
const removeProductsFromCart = async (variantIds) => {
  try {
    const updates = {}

    variantIds.forEach( id => {
      updates[id] = 0
    })

    const body = JSON.stringify({
      updates
    })

    await fetch('/cart/update.js', {
      method: 'POST',
      body,
      headers: {
        'Content-Type': 'application/json'
      }
    })
  } catch (error) {
    console.error(error)
    console.error('Ocurrió un error al tratar de eliminar un producto del carrito')
  }
}

/**
 * this validate a reservation status and the inventory
 * using the respective service endpoint
 * @param { string[] } _ids
 * @returns { {isValid: boolean, _id: string}[] }
 */
const validateReservations = async (_ids = []) => {
  // if( !_id ) throw new Error('_id param is mandatory')
  if( _ids.length === 0 ) return []

  try {
    const res = await fetch(`${ LEND_THE_TREND_BASE_URL }/reservations/validate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ids: _ids })
    })
    const data = await res.json()
    return data.result
  } catch (error) {
    console.error(error)
    return []
  }
}

/**
 * this function fixes the local date to a valid date
 * @param { string } date
 * @returns { Date }
 */
const parseLocalDate = (date = '') => {
  if( typeof date !== 'string' ) throw new Error('date param must to be type string')

  const [dd,mm,yyyy ] = date.split(' al ')[0].split('/')

  if( [dd,mm,yyyy].some( value => !value ) )
    throw new Error('Date param is not a valid format date')

  const formatted = `${mm}/${dd}/${yyyy}`
  const newDate = new Date(formatted)

  if( newDate.toString() === 'Invalid Date' )
    throw new Error('Date param is not a valid format date')

  return newDate
}

const changeItemProperties = async (line, properties) => {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'line': line+1,
        'properties': properties,
        'quantity': 1,
      })
    }) 
    return await res.json()
  } catch (error) {
    console.error(error)
  }
}

const runDailyTasks = async () => {
  const res = await fetch(`${LEND_THE_TREND_BASE_URL}/tasks`)
  return res
}

window.proficient.utils = {
  getBookedDays,
  fetchProduct,
  addProductsToCart,
  createReservation,
  parseLocalDate,
  removeProductsFromCart,
  getCartInfo,
  cancelReservationService,
  validateReservations,
  runDailyTasks
}
